import { isValidPhoneNumber } from "libphonenumber-js";
import PhoneInput, { type Country } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { InputGroup } from "@smartsuite/react-ui/lib";
import * as yup from "yup";
import { FormFieldControl } from "../../../../components/FormFieldControl/FormFieldControl";
import { useFormField } from "../../../../hooks/useFormField";
import { $t } from "../../../../utils/intl";
import type { FormFieldProps } from "../../../types";
import { applyYupDefaults, validateWithYup } from "../../../validator";
import { validatorText } from "../../../validator.text";
import { fieldsText } from "../../fields.text";

import "./PhoneFieldControlSingle.sass";
import type { E164Number } from "libphonenumber-js";
import type { PhoneFormValue } from "../phone.config";

export type PhoneFieldControlSingleProps = FormFieldProps;

export const PhoneFieldControlSingle: React.FunctionComponent<PhoneFieldControlSingleProps> = ({
  caption,
  field,
  formItem,
  label,
  name,
  required,
  readOnly,
}) => {
  const defaultCountry: Country = (field.params.default_country?.toUpperCase() as Country) ?? "";
  const formField = useFormField<PhoneFormValue>({
    name,
    validate: validateWithYup(
      applyYupDefaults(
        yup.array().of(
          yup.string().test("isValidPhoneNumber", $t(validatorText.validationPhone), (value) => {
            return value ? isValidPhoneNumber(value, defaultCountry) : true;
          }),
        ),
        field,
        formItem,
      ),
    ),
  });

  const handleChange = (value: E164Number | undefined): void => {
    formField.onChange(value ? [value] : []);
  };

  return (
    <FormFieldControl
      captionAsTooltip={formItem.params.help_text_as_tooltip}
      caption={caption}
      errorMessage={formField.errorMessage}
      helpText={formItem.params.helpText}
      label={label}
      required={required}
      state={formField.state}
      readOnly={readOnly}
    >
      <InputGroup state={formField.state} inputBackground="white-new">
        <PhoneInput
          disabled={readOnly}
          countryCallingCodeEditable={false}
          defaultCountry={defaultCountry}
          name={formField.name}
          placeholder={$t(fieldsText.phonePlaceholder)}
          value={formField.value?.[0] as E164Number}
          onBlur={formField.onBlur}
          onChange={handleChange}
          onFocus={formField.onFocus}
        />
      </InputGroup>
    </FormFieldControl>
  );
};
